export default {
  admin: [
    {
      icon: 'fa fa-bullhorn',
      label: 'module.post',

      route: {
        name: 'admin.post-list',
        query: {
          page: 1,
          sort: 'created_at=desc',
        },
      },
      roles: ['ROLE_ADMIN', 'ROLE_POST'],
    },
  ],
}